import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCurrencyFormatter]'
})
export class CurrencyFormatterDirective {
  private readonly el: HTMLInputElement;

  constructor(private readonly elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el;
    const cursorPosition = input.selectionStart || 0; // İmleç pozisyonunu al
    let value = input.value;

    // Rakamlar dışındaki karakterleri kaldır
    value = value.replaceAll(/^\d$/g, '');

    if (!value) {
      this.el.value = '0,00';
      input.setSelectionRange(1, 1); // İmleci ilk pozisyona ayarla
      return;
    }

    // Eğer tek bir karakter girilmişse (ilk giriş)
    if (value.length === 1) {
      this.el.value = `${value},00`;
      input.setSelectionRange(1, 1); // İmleci doğru pozisyona ayarla
      return;
    }

    // Sayının tam sayı (integer) ve ondalık (decimal) kısmını belirle
    let integerPart = value.slice(0, -2) || '0'; // Son iki karakter dışındaki kısım tam sayı
    const decimalPart = value.slice(-2).padStart(2, '0'); // Son iki karakter ondalık kısım

    // Integer kısmı üçlü gruplara ayır
    integerPart = integerPart.replaceAll(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Formatlanmış değeri birleştir
    const formattedValue = `${integerPart},${decimalPart}`;
    const prevLength = input.value.length;

    // Input alanını güncelle
    this.el.value = formattedValue;

    // Yeni cursor pozisyonunu ayarla
    const newLength = formattedValue.length;
    const cursorShift = newLength - prevLength;
    const newCursorPosition = cursorPosition + cursorShift;
    input.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  @HostListener('blur', ['$event'])
  onBlur(): void {
    // Input boşsa 0,00 olarak formatla
    if (!this.el.value) {
      this.el.value = '0,00';
    }
  }

  @HostListener('focus', ['$event'])
  onFocus(): void {
    // Input'taki veriyi sıfır olarak başlat
    if (this.el.value === '0,00') {
      this.el.value = '';
    }
  }
}
